// Module
var code = `<div ng-controller="AdminFormUploadFilesField" class="form-group {{form.htmlClass}} schema-form-select"
     ng-class="{
        'has-error': form.disableErrorState !== true && hasError(),
        'has-success': form.disableSuccessState !== true && hasSuccess(),
        'has-feedback': form.feedback !== false
        }"
>
    <label class="control-label {{form.labelHtmlClass}}" ng-show="showTitle()">
        {{form.title}}
    </label>
    <div class="{{form.fieldHtmlClass}}">
        <button class="btn {{ form.style || 'btn-default' }}"
                sf-field-model="replaceAll"
                type="file"
                style="width: 300px;"
                ngf-select="uploadFiles(\$file, \$invalidFiles, form.upload_url, \$\$value\$\$)"
                accept="{{form.accept}}"
                ngf-max-size="{{form.max_size}}"
        >
            <span ng-if="!f"> {{form.button_title || "Select file : "}}</span>
            <span ng-if="f"> {{f.name}} {{f.size | filesize:2}}
                <span ng-show="f.progress >= 0" ng-bind="f.progress + '%'"></span>
            </span>
        </button>
    </div>
    <div class="help-block" sf-message="form.description"></div>

</div>
`;
// Exports
module.exports = code;